import ACTION from '../action_constant';
import API from '../api_config';
import {ajaxGetWithToken, ajaxPostWithToken} from '../util/ajax';
import commonFunctions from '../util/common';

const userProfileActions = {
  viewProfile: (params) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.viewProfile + '?encryptedUserId=' + params.encryptedUserId,
        success: (data) => {
          dispatch({
            type: ACTION.USER_PROFILE.VIEW_PROFILE,
            data : data
          });
        },
        error: (data) => {
          // console.log(data);
        }
      });
    }
  },
  getProfileReviews: (url_params, refreshData) => {
      return (dispatch) => {
          return ajaxGetWithToken ({
              url: API.getProfileReviews + '?encryptedUserId=' + url_params.encryptedUserId + '&offset=' + url_params.offset + '&count=' + url_params.count,
              success: (successData) => {
                  dispatch({
                      type: ACTION.USER_PROFILE.PROFILE_REVIEWS,
                      data: {
                          reviews: successData
                      },
                      refreshData: refreshData
                  })
              },
              error: (error) =>{

              }
          })
      }
  },
  reportUser: (params) => {
    return (dispatch) => {
      return ajaxPostWithToken ({
          url: API.reportUser,
          data: params,
          success: (successData) => {

          },
          error: (error) =>{

          }
      })
    }
  }
};

module.exports = userProfileActions;



// WEBPACK FOOTER //
// app/user_profile/user_profile_actions.jsx